import { uiText } from '../../i18n/uiText';
import React from 'react';
import { Check } from 'lucide-react';

export default function ProcessStepper({
  steps,
  currentIndex = 0,
  onStepClick,
  ariaLabel = uiText("Этапы процесса"),
}) {
  const safeSteps = Array.isArray(steps) ? steps : [];
  return (
    <div
      className="process-stepper"
      style={{ '--process-step-count': Math.max(safeSteps.length, 1) }}
      aria-label={ariaLabel}
    >
      {safeSteps.map((step, index) => {
        // An advanced stage is not proof that an optional document exists.
        const completed = step.completed ?? (index < currentIndex);
        const current = index === currentIndex;
        const className = `process-step ${completed ? 'is-completed' : ''} ${current ? 'is-current' : ''}`;
        const content = (
          <>
            <span className="process-step-index">{completed ? <Check size={12} /> : index + 1}</span>
            <span className="process-step-label">{step.label}</span>
          </>
        );
        return typeof onStepClick === 'function' || step.onClick ? (
          <button
            key={step.key || step.label}
            type="button"
            className={className}
            aria-current={current ? 'step' : undefined}
            onClick={() => (step.onClick || onStepClick)?.(step, index)}
          >
            {content}
          </button>
        ) : (
          <div
            key={step.key || step.label}
            className={className}
            aria-current={current ? 'step' : undefined}
          >
            {content}
          </div>
        );
      })}
    </div>
  );
}
